<template>
    <div>
        <Toolbar>
            <BackButton :to="offer.name" :href="$route('offers.edit', offer.id)"/>

            <template v-slot:right>
                <button
                    class="btn btn-bg-white btn-text-dark-50 btn-icon-primary btn-hover-primary font-weight-bold px-5"
                    @click="addStoresModalVisible = true"
                >
                    <i class="fas fa-plus-square"/>
                    {{ __('actions.add_thing', {thing: __('general.stores')}) }}
                </button>
            </template>
        </Toolbar>

        <AddOfferStoresModal :offer="offer"
                             :visible="addStoresModalVisible"
                             @update:visible="v => addStoresModalVisible = v"
        />

        <Card>
            <template v-slot:icon>
                <i class="fas fa-building"/>
            </template>
            <template v-slot:title>
                {{ __('actions.select_thing', {thing: __('general.stores')}) }}
            </template>
            <template v-slot:description>
                {{ __('store.manage_selected') }}
            </template>
            <template v-slot:toolbar>
                <button v-if="stores.isNotEmpty()"
                        class="btn btn-light-danger"
                        :disabled="selectedStores.isEmpty()"
                        @click="removeSelectedStores"
                >
                    <i class="fas fa-trash"/>
                    {{
                        __('actions.remove_thing', {thing: __('general.things.selected', {things: __('general.stores')})})
                    }}
                </button>
            </template>

            <div v-if="stores.isEmpty()" class="text-muted">
                {{ __('general.things.none_present_yet', {things: __('general.stores')}) }}
            </div>
            <div v-else class="table-responsive">
                <table class="table table-hover table-vertical-center">
                    <thead>
                    <tr>
                        <th class="w-50px"/>
                        <th>{{ __('general.name') }}</th>
                        <th>{{ __('general.address.address') }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="store in stores"
                        :key="store.id"
                        class="cursor-pointer"
                        :class="{'bg-light-primary': selectedStores.includes(store.id)}"
                        @click="toggleRow(store.id)"
                    >
                        <td class="text-center">
                            <div class="checkbox-inline user-select-none pointer-events-none">
                                <label class="checkbox checkbox-checkbox-primary">
                                    <input type="checkbox"
                                           :ref="`store${store.id}`"
                                           :checked="selectedStores.includes(store.id)"
                                           @input="addOrRemoveStoreFromSelection(store.id, $event.target.checked)"
                                    >
                                    <span/>
                                </label>
                            </div>
                        </td>
                        <td>
                            {{ store.attributes.name }}
                        </td>
                        <td>
                            <StoreAddress :store="store"/>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </Card>
    </div>
</template>

<script>
import Card from "@components/Cards/Card.vue";
import Toolbar from "@components/Toolbar.vue";
import BackButton from "@components/BackButton.vue";
import StoreAddress from "@components/Store/StoreAddress.vue";
import AddOfferStoresModal from "@components/SelectedOffers/AddOfferStoresModal.vue";
import AddOfferArticlesModal from "@components/SelectedOffers/AddOfferArticlesModal.vue";

export default {
    components: {AddOfferArticlesModal, AddOfferStoresModal, StoreAddress, BackButton, Toolbar, Card},

    props: {
        offer: Object,
        stores: Array
    },

    data() {
        return {
            selectedStores: [],
            addStoresModalVisible: false
        }
    },

    methods: {
        toggleRow(ean) {
            this.$refs[`store${ean}`][0].click();
        },

        addOrRemoveStoreFromSelection(storeUuid, isSelected) {
            if (isSelected) {
                this.selectedStores.pushUnique(storeUuid);
            } else {
                this.selectedStores.removeElement(storeUuid);
            }
        },

        removeSelectedStores() {
            this.$inertia.post(this.$route('offers.stores.update', this.offer.id), {
                store_uuids: this.selectedStores,
                action: 'remove'
            })
        }
    }
}
</script>
